<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="isAccessPage" />
      <not-access v-else />
    </keep-alive>
  </div>
</template>

<script>
import axios from 'axios';
import NotAccess from './components/NotAccess.vue';

export default {
  name: 'App',
  data() {
    return {
      isAccessPage: true,
      ipList: [
        '175.209.237.106',
        '218.39.38.151',
        '211.192.203.180',
        '221.148.128.204',
        '211.54.1.157',
        '211.54.1.150',
        '211.196.211.144',
        '218.145.118.68',
        '118.130.200.37',
        '218.39.38.234',
        '124.55.47.215',
        '192.168.0.197'
      ],
    };
  },
  computed: {},
  mounted() {
    console.log(this.ipList);
    this.getIpClient();
  },
  watch: {},
  methods: {
    async getIpClient() {
      try {
        const response = await axios.get('https://api64.ipify.org?format=json');
        if (!this.ipList.includes(response.data.ip)) {
          this.isAccessPage = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: { NotAccess },
};
</script>

<style>
@import 'App.css';
</style>
